import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["calendarButtonAltText", "clearButtonAltText", "collapsedTitleText", "collapsedCloseButtonAltText", "disabled", "inputProps", "inputRef", "onInputChange", "onInputError", "popoverProps", "renderPopupContent"];
import React, { useState } from 'react';
import { WithFlyout, FlyoutContent } from "../../flyout";
import { View } from "../../layout";
import { PopoverController } from "../../popover";
import { useBreakpoints } from "../../responsive";
import { getErrorColorOverride, pickDataProps, withTestAttributes } from "../../utils";
import { DateInputField } from "../date-input-field";
import { AccessibleDatePickerButton } from "./AccessibleDatePickerButton";
import { POPOVER_WIDTH } from "./constants";
import { jsx as ___EmotionJSX } from "@emotion/core";

var DateInputWithPopup = function DateInputWithPopup(_ref) {
  var calendarButtonAltText = _ref.calendarButtonAltText,
      clearButtonAltText = _ref.clearButtonAltText,
      collapsedTitleText = _ref.collapsedTitleText,
      collapsedCloseButtonAltText = _ref.collapsedCloseButtonAltText,
      disabled = _ref.disabled,
      inputProps = _ref.inputProps,
      inputRef = _ref.inputRef,
      onInputChange = _ref.onInputChange,
      onInputError = _ref.onInputError,
      popoverProps = _ref.popoverProps,
      renderPopupContent = _ref.renderPopupContent,
      forwardedProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var viewport = useBreakpoints();

  var renderInput = function renderInput(_ref2) {
    var isOpen = _ref2.isOpen,
        isReadOnly = _ref2.isReadOnly,
        toggle = _ref2.toggle;
    var dataProps = pickDataProps(forwardedProps);
    var parentInsetElement = disabled ? undefined : ___EmotionJSX(AccessibleDatePickerButton, {
      calendarButtonAltText: calendarButtonAltText,
      iconColor: getErrorColorOverride(inputProps.error, inputProps.warning),
      isOpen: isOpen,
      toggle: toggle
    });
    return ___EmotionJSX(DateInputField, _extends({}, inputProps, dataProps, {
      clearButtonAltText: clearButtonAltText,
      disabled: disabled,
      isCalendarOpen: isOpen,
      onChange: onInputChange,
      onClick: toggle,
      onError: onInputError,
      parentInsetElement: parentInsetElement,
      readOnly: isReadOnly,
      ref: inputRef
    }));
  };

  var renderFlyout = function renderFlyout() {
    return ___EmotionJSX(WithFlyout, {
      renderFlyout: function renderFlyout(_ref3) {
        var close = _ref3.close;
        return ___EmotionJSX(View, {
          width: "100vw",
          height: "100vh"
        }, ___EmotionJSX(FlyoutContent, {
          closeButtonAltText: collapsedCloseButtonAltText,
          maxWidth: null,
          onCloseButtonClick: close,
          titleText: collapsedTitleText
        }, renderPopupContent(close)));
      },
      zIndex: "highest"
    }, function (_ref4) {
      var open = _ref4.open;
      return renderInput({
        isOpen: false,
        isReadOnly: true,
        toggle: open
      });
    });
  };

  var renderPopover = function renderPopover() {
    var handleClose = function handleClose() {
      setIsOpen(false);
    };

    var handleToggle = function handleToggle(event) {
      event && event.stopPropagation();
      setIsOpen(!isOpen);
    };

    var handlePopoverEscKey = function handlePopoverEscKey() {
      inputRef && inputRef.current && inputRef.current.focus();
    };

    return ___EmotionJSX(React.Fragment, null, renderInput({
      isOpen: isOpen,
      isReadOnly: false,
      toggle: handleToggle
    }), ___EmotionJSX(PopoverController, _extends({}, popoverProps, {
      close: handleClose,
      isOpen: isOpen,
      onEscKey: handlePopoverEscKey,
      target: inputRef
    }), ___EmotionJSX(View, {
      width: POPOVER_WIDTH
    }, renderPopupContent(handleClose))));
  };

  return viewport.matches.s ? renderFlyout() : renderPopover();
};

export default withTestAttributes({})(DateInputWithPopup);